import { createContext } from 'react';

const PagoOnlineContext = createContext();

export default PagoOnlineContext;
